<template>
  <v-list>
    <layer-group :layer-group="layerCategories"></layer-group>
  </v-list>
</template>

<script>
import layerGroup from "./menu/layerGroup";
import {mapState} from "vuex"

export default {
  name: "Menu",
  components: {layerGroup},
  methods: {},
  computed: {
    ...mapState("map", ["layerCategories"])
  }
}
</script>

<style scoped>

</style>